import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbsQuickMenuComponent } from './breadcrumbs-quick-menu.component';
import { RouterModule } from '@angular/router';
import { MatIconModule, MatButtonModule, MatMenuModule, MatInputModule, MatSelectModule, MatOptionModule } from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { IconModule } from '@visurel/iconify-angular';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { createTranslateLoader, MyMissingTranslationHandler, NotTranslatedService } from 'src/app/translate.common';
import { HttpClient } from '@angular/common/http';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    FlexLayoutModule,
    MatButtonModule,
    MatMenuModule,
    IconModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    TranslateModule.forRoot({
      //language code
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      missingTranslationHandler: {
        provide: MyMissingTranslationHandler,
        useClass: MyMissingTranslationHandler,
        deps: [NotTranslatedService]
      },
      isolate: true,
    }),
  ],
  declarations: [BreadcrumbsQuickMenuComponent],
  exports: [BreadcrumbsQuickMenuComponent]
})
export class BreadcrumbsQuickMenuModule { }
